import "./Landing.css";
import "../App.css"

import backgroundImg from "../common/photos/foolsMoon.jpg"
import twitterIcon from "../common/icons/twitter-icon.svg"
import instagramIcon from "../common/icons/instagram-icon.svg"
import discordIcon from "../common/icons/discord-icon.png"
import blueSkyIcon from "../common/icons/bluesky-icon.svg"
import clubLogo from "../common/club-logo-margin-blue.png"
import calendarIcon from "../common/icons/calendar-icon.svg"
import { gapi } from 'gapi-script'
import date from 'date-and-time';

import { BrowserView, MobileView } from "react-device-detect"
import { useEffect, useState } from "react";
import moment from "moment";


export default function LandingView(): JSX.Element {
    const openInNewTab = (url: string) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const calendarID = process.env.REACT_APP_CALENDAR_ID;
    const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    
    const [events, setEvents] = useState<any[]>([]);
    const generateCalendar = (calendarID: string | undefined, apiKey: string | undefined): any => {
        function initiate() {
            gapi.client
            .init({
                apiKey: apiKey,
            })
            .then(function () {
                return gapi.client.request({
                    path: `https://www.googleapis.com/calendar/v3/calendars/${calendarID}/events`,
                    params: {
                        singleEvents: true,
                        timeMin: new Date().toISOString(),
                        orderBy: "startTime",
                        maxResults: 10,
                    },
                });
            })
            .then(
                (response) => {
                    let gotEvents = response.result.items;
                    setEvents(gotEvents);
                },
                function (err) {
                    return [false, err]
                }
            )
        }
        gapi.load('client', initiate);
    }
    useEffect(() => {
        generateCalendar(calendarID, apiKey)
    }, []);

    return (

        <div id="landing" className="view-section-container">
            <div className="view-content-container">
                {/* Top icons and social media buttons */}
                <div id="top-buttons-container" className="top-icons">
                    <div className="left-icons">
                        <a href='/'>
                            <img id="top-club-logo" src={clubLogo} alt="Furries at UMich Logo" className="top-logo"/>
                        </a>
                    </div>
                    <div className="right-icons">
                        {/* <button className="icon-button-invert"
                                onClick={() => openInNewTab("https://x.com/FurriesAtUMich")}>
                            <img src={twitterIcon} alt="Twitter"/>
                        </button> */}
                        <button className="icon-button-invert"
                                onClick={() => openInNewTab("https://discord.gg/Jj7tH5zxzg")}>
                            <img src={discordIcon} alt="Discord"/>
                        </button>
                        <button className="icon-button-invert"
                                onClick={() => openInNewTab("https://www.instagram.com/furriesatumich/")}>
                            <img src={instagramIcon} alt="Instagram"/>
                        </button>
                        {/* <button className="icon-button-invert"
                                onClick={() => openInNewTab("https://bsky.app/profile/furriesatumich.bsky.social")}>
                            <img src={blueSkyIcon} alt="Bluesky"/>
                        </button> */}
                        <button className="icon-button-invert"
                                onClick={() => openInNewTab("https://calendar.google.com/calendar/u/4?cid=YW50aHJvYXJ0YXNzb2NpYXRpb25AZ21haWwuY29t")}>
                            <img src={calendarIcon} alt="Calendar"/>
                        </button>
                    </div>
                </div>

                {/* Landing intro */}
                <div className="invert-content">
                    <h1 className="landing-main-text">
                        Furries at UMich
                    </h1>
                    <p className="landing-main-description">
                    We are Furries at UMich, a registered voluntary student organization at the University of Michigan - Ann Arbor, providing a safe space for individuals interested in anthropomorphic characters and subculture.
                    </p>
                    <a className="landing-main-button" href="#about">
                        Learn More
                    </a>
                </div>

                <div style={{height: "100px"}}></div>
                
                {/* Upcoming Events */}
                <div className="invert-content">
                    <h2>Upcoming Events</h2>
                    <BrowserView>
                        { events.filter((e) => Date.parse(e.end.dateTime) > Date.now()).sort((a,b) => Date.parse(a.start.dateTime)-Date.parse(b.start.dateTime)).slice(0,2).map((event) => {
                            return (
                                <div className="upcoming-event-container-desktop" key={event.sequence}>
                                    <h4 className="upcoming-event-name">
                                        {event.summary ? event.summary : ""}
                                    </h4>
                                    <p className="upcoming-event-location">
                                        {event.location ? event.location.includes("Sample Location") ? "TBD" : event.location : ""}
                                    </p>
                                    <p className="upcoming-event-time">
                                        {event.start.dateTime && event.end.dateTime ? moment(event.start.dateTime).format("h:mm a").toString() + " - " + moment(event.end.dateTime).format("h:mm a").toString() : ""}
                                    </p>
                                    <p className="upcoming-event-time">
                                        {event.start.dateTime ? moment(event.start.dateTime).format("dddd, LL").toString() : ""}
                                    </p>
                                </div>
                            )
                        })}
                        <div className="upcoming-event-container-desktop">
                            <p className="upcoming-event-single-text">
                                Join our Discord channel for meeting info & a Telegram invite, follow our Instagram, or add our calendar!
                            </p>
                            {/* <img src={twitterIcon} className="upcoming-event-icon"
                                alt="Twitter Icon"
                                onClick={() => openInNewTab("https://x.com/FurriesAtUMich")}/> */}
                            <img src={discordIcon} className="upcoming-event-icon"
                                alt="Discord Icon"
                                onClick={() => openInNewTab("https://discord.gg/Jj7tH5zxzg")}/>
                            <img src={instagramIcon} className="upcoming-event-icon"
                                alt="Instagram Icon"
                                onClick={() => openInNewTab("https://www.instagram.com/furriesatumich/")}/>
                            <img src={calendarIcon} className="upcoming-event-icon"
                                    alt="Calendar Icon"
                                    onClick={() => openInNewTab("https://calendar.google.com/calendar/u/4?cid=YW50aHJvYXJ0YXNzb2NpYXRpb25AZ21haWwuY29t")}/>
                        </div>
                    </BrowserView>
                    <MobileView>
                        { events.filter((e) => Date.parse(e.end.dateTime) > Date.now()).sort((a,b) => Date.parse(a.start.dateTime)-Date.parse(b.start.dateTime)).slice(0,1).map((event) => {
                            return (
                                <div className="upcoming-event-container-desktop" key={event.sequence}>
                                    <h4 className="upcoming-event-name">
                                        {event.summary ? event.summary : ""}
                                    </h4>
                                    <p className="upcoming-event-location">
                                        {event.location ? event.location.includes("Sample Location") ? "TBD" : event.location : ""}
                                    </p>
                                    <p className="upcoming-event-time">
                                        {event.start.dateTime && event.end.dateTime ? moment(event.start.dateTime).format("h:mm a").toString() + " - " + moment(event.end.dateTime).format("h:mm a").toString() : ""}
                                    </p>
                                    <p className="upcoming-event-time">
                                        {event.start.dateTime ? moment(event.start.dateTime).format("dddd, LL").toString() : ""}
                                    </p>
                                </div>
                            )
                        })}
                        { events.length > 0 &&
                            <button className="upcoming-event-more-button-mobile"
                                onClick={() => openInNewTab("https://calendar.google.com/calendar/u/4?cid=YW50aHJvYXJ0YXNzb2NpYXRpb25AZ21haWwuY29t")}>
                            </button>
                        }


                        <div className="upcoming-event-container-mobile-small">
                            <span>Follow for updates!</span>
                            <div className="right-icons">
                            <img src={twitterIcon} className="upcoming-event-icon"
                                alt="Twitter Icon"
                                onClick={() => openInNewTab("https://x.com/FurriesAtUMich")}/>
                            <img src={instagramIcon} className="upcoming-event-icon"
                                alt="InstagramIcon"
                                onClick={() => openInNewTab("https://www.instagram.com/furriesatumich/")}/>
                            <img src={discordIcon} className="upcoming-event-icon"
                                alt="Discord Icon"
                                onClick={() => openInNewTab("https://discord.gg/Jj7tH5zxzg")}/>
                            </div>
                        </div>
                    </MobileView>
                </div>
            </div>

            {/* Bakground */}
            <div className="color-overlay-blue"></div>
            <img src={backgroundImg} id="landing-background-img" alt="Fursuiters at Fool Moon 2026"/>
        </div>
    );
        
}
